<template>
<!-- 使用人信息-查看眼健康 -->
    <div class="content">
        <p class="title"><font color="#1989fa">{{this.myfilename}}</font>的档案记录</p>

        <!-- <router-link :to="{name: 'NewFiles', params: {myfileid: this.myfileid}}"> -->
        <div v-bind:disabled="flag" class="add" @click="goNew">
            <button >新建档案 <span>+</span></button>
        </div>
        <!-- </router-link> -->

        <div class="eyeHealthList">
            <van-loading v-if="loading" />
            <div style="padding: 0 14px;background: #fff;">
                <van-row class="row">
                    <van-col class="col_left" span="12">日期</van-col>
                    <van-col span="12">操作</van-col>
                </van-row>
            </div>
            <div style="padding: 0 14px;background: #fff;">
                <van-row v-for="(item,index) in myfiles" :key="index" class="row">
                    <van-col class="col_left" span="12">{{item.day}}</van-col>
                    <van-col span="12" @click="go_detail(item.eyeid)" class="detail">
                            详情
                    </van-col>
                </van-row>
            </div>

        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Row, Col } from 'vant';
import { Toast } from 'vant';
import { Loading } from 'vant';


Vue.use(Loading);
Vue.use(Toast);
Vue.use(Row).use(Col);
export default {

    data() {
        return {
            loading: false,
            myfilename: '',
            myfiles: [],

            myfileid: '',

            eyeid: '',
            lastTime: '',
            flag: false, // 为真不能点击
            my_local_fileid: '',
            my_local_name: '',
        };
    },

    created() {
        this.getEyeHealthList()
    },
    methods: {
        goNew() {
            if(!this.flag) {
                this.$router.push({
                    name: 'NewFiles',
                    parame: {
                        myfileid: this.$route.params.myfileid
                    }
                })
            }else {
                Toast('一个月只能添加一次噢！')
            }
        },
        // 查看详情
        go_detail(eyeid) {
            this.$router.push({
                name: 'ModifyFiles',
                params: {
                    eyeid: eyeid,
                    myfileid: this.myfileid

                }
            })
        },

        getEyeHealthList() {
            console.log(this.$route);
            this.axios.interceptors.request.use((config)=>{
                // 在发送请求之前做些什么
                this.loading = true
                return config;
            }, function (error) {
                return Toast('出现错误');
            });

            this.axios.interceptors.response.use((response)=> {
                // 对响应数据做点什么
                this.loading = false
                return response;
            }, function (error) {
                // 对响应错误做点什么
                return Toast('出现错误');
            });

            this.axios.get('/weixin/getMyfileEyeList',{
                params: {
                    myfileid: this.$route.params.myfileid
                }
            })
            .then(res=>{
                this.myfilename = res.data.myfilename

                this.myfileid = res.data.myfileid

                this.myfiles = res.data.eye
              if(res.data.eye.size>0){
                this.lastTime = res.data.eye[res.data.eye.length-1].day
              }

                this.getTime()
           })
        },

        // 获取创建时间
        // 从创建时间起 一个月内
        // 比较当前时间是否在一个月内
        // 如果在不能点 如果不在 可以点


        getTime() {
          if(this.lastTime!=null&&this.lastTime!=""){
            debugger;
            let today = new Date(this.lastTime).getTime()
            let lastDay = getTimeByDay(30) //获取30天后的日期
            let lastTime = formatTime(lastDay)

            function getTimeByDay(num) {
              return today + 60 * 60 * 1000 * 24 * num;
            }

            function formatTime(time) {
              return new Date(time).toISOString().split('T')[0];
            }
            let startDate = new Date(today);
            let endDate = new Date(lastTime);

            let dateList = []

            endDate.setDate(startDate.getDate());
            while((endDate.getTime() - startDate.getTime()) >= 0) {
              let month = (startDate.getMonth() + 1).toString().length === 1 ? "0" + (startDate.getMonth() + 1).toString() : (startDate.getMonth() + 1);
              let day = startDate.getDate().toString().length === 1 ? "0" + startDate.getDate() : startDate.getDate();
              dateList.push(month + "-" + day);
              startDate.setDate(startDate.getDate() + 1);
            }

            // 判断今天是否在list中
            let a = formatTime(new Date()).slice(5,10)
            if(dateList.indexOf(a)!=-1) {
              this.flag = true
            }
          }


        }


    },

};
</script>
<style>
    .van-loading__spinner {
        width: 100px;
        height: 100px;
    }
</style>

<style scoped>
.title {
    text-align: center;
    font-weight: 600;
    font-size: 38px;
    margin: 38px 0 30px;
}

.add {
    text-align: center;
    width: 258px;
    margin: 0 auto;
}

.add button {
    width: 258px;
    height: 66px;
    line-height: 66px;
    background: #eac645;
    border-radius: 25px;
    color: #fff;
    font-size: 38px;
}

.add button span {
    vertical-align: 2px;
    color: #fff;
}

.eyeHealthList {
    margin-top: 38px;
    text-align: center;
}
.row {
    background: #fff;
    height: 90px;
    line-height: 90px;
    border-bottom: 1px solid #f0f0f0;
}
.col_left {
    font-size: 36px;
    border-right: 1px solid #f0f0f0;
}
.detail {
    font-size: 36px;
    color: #eac645;
}
</style>



// WEBPACK FOOTER //
// src/views/SeeEyeHealth.vue